import React, { useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  DefaultLegendContent,
} from 'recharts';
import '../../styles/dashboardStyle/VGVDashboard.css';
import { Info } from 'lucide-react';
import { MesValor } from '../../API/dashboardDetailsService';

interface VGVDashboardProps {
  dados: MesValor[];
}

const VGVDashboard: React.FC<VGVDashboardProps> = ({ dados }) => {
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: 'Este gráfico exibe o VGV mensal realizado e a projeção, permitindo acompanhar a evolução financeira.',
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: '' });

  const renderCustomLegend = (props: any) => {
    if (!props.payload) return null;
    const ordem = ['VGV Realizado', 'Projeção'];
    const itensOrdenados = [...props.payload].sort(
      (a, b) => ordem.indexOf(a.value) - ordem.indexOf(b.value)
    );

    return (
      <DefaultLegendContent
        {...props}
        payload={itensOrdenados.map((entry) => ({
          ...entry,
          value: <span style={{ color: entry.color }}>{entry.value}</span>,
        }))}
      />
    );
  };

  return (
    <div className="card-vgv-dash info-card">
      <div className="card-vgv-header-dash">
        <h3 className="card-vgv-title-dash">VGV mensal</h3>
        <Info className="info-btn" size={20} onClick={handleInfoClick} />
      </div>

      <ResponsiveContainer width="100%" height={225}>
        <LineChart data={dados}>
          <XAxis dataKey="categoria" style={{ fontSize: '11px' }} />
          <YAxis
            style={{ fontSize: '9px' }}
            tickFormatter={(value) => `R$ ${(value / 1_000_000).toFixed(1)}M`}
          />
          <Tooltip formatter={(value: number) => `R$ ${(value / 1_000_000).toFixed(2)}M`} />
          <Legend
            verticalAlign="bottom"
            align="center"
            content={renderCustomLegend}
            wrapperStyle={{ marginTop: -6 }}
          />

          {/* Linha Realizado */}
          <Line
            type="monotone"
            dataKey="realizado"
            name="VGV Realizado"
            stroke="#29306A"
            strokeWidth={2}
            dot={{ r: 3, stroke: '#29306A', strokeWidth: 1, fill: '#fff' }}
            activeDot={{ r: 5 }}
          />

          {/* Linha Projeção */}
          <Line
            type="monotone"
            dataKey="projecao"
            name="Projeção"
            stroke="#32BEF0"
            strokeWidth={2}
            strokeDasharray="3 1"
            dot={{ r: 3, stroke: '#32BEF0', strokeWidth: 1, fill: '#fff' }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VGVDashboard;
